{
  "account": {
    "fields": {
      "userId": "ID utilis.",
      "webId": "Web ID",
      "userRole": "Rôle",
      "accountType": "Type de compte"
    },
    "sections": {
      "security": "Sécurité"
    },
    "buttons": {
      "addPassword": "Ajouter un mot de passe",
      "refresh": "Actualiser",
      "logout": "Quitter"
    },
    "messages": {
      "passwordEnabled": "L'authentification par mot de passe est activée pour votre compte.",
      "addPasswordPrompt": "Ajoutez un mot de passe pour activer la connexion par mot de passe en complément de votre méthode SSO."
    },
    "accountTypes": {
      "admin": "Admin",
      "fboUser": "Util. FBO"
    },
    "addPasswordDialog": {
      "title": "Ajouter l'authentification mot de passe",
      "successMessage": "Mot de passe ajouté avec succès ! Vous pouvez maintenant vous connecter avec votre e-mail et votre mot de passe.",
      "description": "Ajoutez un mot de passe à votre compte ({{userEmail}}) pour activer la connexion par mot de passe en complément de votre méthode SSO existante.",
      "labels": {
        "newPassword": "Nouv. mot de passe",
        "confirmPassword": "Confirmer mot de passe",
        "strength": "Force : {{strength}}"
      },
      "validationErrors": {
        "tooShort": "Le mot de passe doit contenir au moins 8 caractères",
        "needsUppercase": "Le mot de passe doit contenir au moins une lettre majuscule",
        "needsLowercase": "Le mot de passe doit contenir au moins une lettre minuscule",
        "needsNumber": "Le mot de passe doit contenir au moins un chiffre",
        "noMatch": "Mots de passe différents",
        "setFailed": "Mot de passe non défini",
        "genericError": "Une erreur s'est produite"
      },
      "strength": {
        "tooShort": "Trop court",
        "weak": "Faible",
        "fair": "Moyen",
        "good": "Bon",
        "strong": "Fort"
      },
      "requirements": "Doit contenir au moins 8 caractères avec majuscules, minuscules et chiffres",
      "buttons": {
        "cancel": "Annuler",
        "adding": "Ajout...",
        "addPassword": "Ajouter un mot de passe",
        "close": "Fermer"
      }
    },
    "roleSwitcher": {
      "title": "Test des rôles (Admin uniquement)",
      "description": "Testez l'application avec différents rôles utilisateur pour vérifier les permissions et le comportement de l'interface. Il s'agit d'une simulation côté client uniquement, sans impact sur la base de données.",
      "selectLabel": "Tester le rôle",
      "activeMessage": "Le test de rôle est actif. Utilisez le bouton flottant (en bas à droite) pour changer de rôle ou quitter.",
      "buttonStartTesting": "Tester en tant que {{role}}"
    },
    "languageSwitcher": {
      "title": "Test de langue (Admin uniquement)",
      "description": "Activer un bouton flottant pour changer rapidement de langue et tester les traductions.",
      "buttonEnable": "Activer le sélecteur de langue",
      "buttonDisable": "Désactiver le sélecteur de langue",
      "activeMessage": "Les tests de langue sont actifs. Utilisez le bouton flottant (en bas à droite) pour changer de langue."
    }
  },
  "configuration": {
    "sections": {
      "personalPreferences": "Préférences personnelles",
      "globalPermissions": "Permissions globales",
      "rolePermissions": "Autorisations du rôle",
      "emailIngestion": "Adresse d'ingestion e-mail"
    },
    "descriptions": {
      "personalPreferences": "Personnalisez vos préférences d'affichage et de comportement.",
      "globalPermissions": "Activer/désactiver les permissions globales. Celles-ci seront appliquées à tous les utilisateurs, quel que soit leur rôle.",
      "rolePermissions": "Gérer les permissions pour chaque rôle utilisateur. Ces permissions seront appliquées à tous les utilisateurs de chaque rôle.",
      "emailIngestion": "Transférez les horaires de vols et réservations à cette adresse e-mail pour importation automatique."
    },
    "emailIngestion": {
      "copied": "Adresse e-mail copiée",
      "copyTooltip": "Copier"
    },
    "personalPreferences": {
      "darkMode": "Mode sombre",
      "hideLockReminder": "Masquer le rappel des aéronefs verrouillés",
      "showAircraftLabels": "Afficher étiquettes avions",
      "language": "Langue"
    },
    "globalPermissions": {
      "excludeObstructions": "Exclure les obstacles, périmètres de sécurité et zones interdites au remorquage ?",
      "forceDisplayNotes": "Les notes dans « Paramètres d'affichage » affichent tout le texte saisi",
      "enableScheduling": "Activer la planification",
      "displayDetailedDecisionLog": "Afficher le dialogue de décision détaillé",
      "airportCode": "Code aéroport",
      "useListHoldingArea": "Utiliser une zone d'attente en liste",
      "enableAutoParking": "Activer le stationnement auto",
      "enableOpsCenter": "Activer Ops Center",
      "useMetricSystem": "Système métrique",
      "timezone": "Fuseau h."
    },
    "tooltips": {
      "excludeObstructions": "Par défaut, AirPlx utilise la largeur et la profondeur du hangar comme surface totale pour les calculs d'utilisation. Vous pouvez exclure les obstructions (bureaux, cages, etc.) et les périmètres de sécurité (zones sans remorquage) si nécessaire.",
      "enableScheduling": "Afficher la planification des vols, les pages de planning et les vues chronologiques. Si désactivé, ces fonctionnalités seront masquées de l'interface.",
      "displayDetailedDecisionLog": "Afficher les statistiques détaillées, l'onglet du journal de décisions et les métriques de performance dans la fenêtre de résultats AutoPark. À des fins de développement et de débogage.",
      "airportCode": "Code ICAO ou IATA de l'aéroport pour ce FBO (ex. : KBZN, KJFK). Utilisé pour le suivi des vols FlightAware dans le centre des opérations.",
      "useListHoldingArea": "Activé : zone d'attente moderne (liste). Désactivé : zone d'attente visuelle (canevas).",
      "enableAutoParking": "Lorsque activé, les fonctionnalités de stationnement automatique sont disponibles. Remarque : ce paramètre ET le bouton AutoParking du tarmac (Éditeur de tarmac) doivent être activés.",
      "enableOpsCenter": "Afficher Ops Center dans la navigation pour les administrateurs système. Ops Center fournit le suivi des vols en temps réel, la surveillance des arrivées et départs, ainsi que les outils de workflow CSR. Lorsque cette option est désactivée, Ops Center sera masqué dans le menu de navigation.",
      "timezone": "Fuseau horaire IANA pour cet emplacement FBO. Utilisé pour convertir les heures locales lors de l'ingestion des e-mails (par exemple, lorsque FBO One envoie les heures d'arrivée en heure locale)."
    },
    "permissions": {
      "displayEstimatedValue": {
        "label": "Afficher la valeur estimée",
        "description": "Afficher la valeur estimée sur le tableau de bord."
      },
      "addTeamMembers": {
        "label": "Ajouter des membres",
        "description": "Ajouter des membres à l'équipe du FBO."
      },
      "modifyTenants": {
        "label": "Modifier locataires",
        "description": "Gérez les immatriculations d'aéronefs et les informations des locataires."
      },
      "modifyLayout": {
        "label": "Modifier la mise",
        "description": "Modifier les éléments de disposition (spots, zones, obstacles, images de référence, points de calibration, marquages, portes, baies, piles)."
      },
      "createTrips": {
        "label": "Créer des vols",
        "description": "Créer des vols et des réservations."
      },
      "deleteTrips": {
        "label": "Supprimer vols",
        "description": "Supprimer les vols et réservations."
      },
      "useFavorites": {
        "label": "Favoris",
        "description": "Utilisez la fonction favoris pour enregistrer, charger et modifier vos piles favorites."
      },
      "viewOnly": {
        "label": "Lecture seule",
        "description": "Mode lecture seule : l'utilisateur peut consulter toutes les données mais ne peut rien créer, modifier ou supprimer."
      },
      "modifyRates": {
        "label": "Modifier tarifs",
        "description": "Modifier les tarifs et les taux de référence."
      },
      "modifyInfrastructure": {
        "label": "Modifier l'infrastructure",
        "description": "Modifier l'infrastructure (hangars, tarmacs, équipements)."
      },
      "modifyConfiguration": {
        "label": "Modifier la configuration",
        "description": "Modifier les paramètres FBO (affichage services, tags notes ops)."
      }
    },
    "roles": {
      "fboAdmin": "Admin FBO",
      "manager": "Gérant",
      "operator": "Opérateur",
      "csr": "CSR"
    },
    "limitedAccess": {
      "title": "Accès limité",
      "message": "Vous êtes connecté en tant que {{role}}. Seuls les administrateurs FBO peuvent consulter et modifier les permissions des rôles. Contactez votre administrateur si vous avez besoin d'un accès."
    },
    "placeholders": {
      "airportCode": "KBZN",
      "timezone": "Fuseau horaire..."
    },
    "vipTags": {
      "title": "Tags VIP",
      "description": "Configurez les étiquettes VIP pour classifier les locataires de base. Les étiquettes apparaîtront sous forme de badges colorés sur les aéronefs et les vols.",
      "loading": "Chargement des tags VIP...",
      "noTags": "Aucun tag VIP configuré. Ajoutez votre premier tag ci-dessous.",
      "addNew": "Ajouter un tag",
      "fields": {
        "label": "Libellé tag",
        "newLabel": "Nouveau libellé de tag (ex. : VIP, YC)"
      },
      "buttons": {
        "add": "Ajouter"
      },
      "colorPicker": {
        "chooseColor": "Choisir une couleur",
        "customColor": "Couleur perso..."
      },
      "success": {
        "created": "Tag VIP créé avec succès",
        "deleted": "Tag VIP supprimé"
      },
      "errors": {
        "loadFailed": "Échec du chargement des tags VIP",
        "createFailed": "Échec de la création du tag VIP",
        "updateFailed": "Échec de la modification du tag VIP",
        "deleteFailed": "Échec de la suppression du tag VIP",
        "reorderFailed": "Échec réorganisation étiquettes VIP"
      },
      "errorTitle": "Erreur chargement tags VIP",
      "errorDescription": "Une erreur s'est produite lors du chargement des paramètres des étiquettes VIP. Veuillez actualiser la page."
    }
  },
  "userManagement": {
    "search": {
      "placeholder": "Rechercher par e-mail"
    },
    "table": {
      "headers": {
        "name": "Nom",
        "email": "E-mail",
        "role": "Rôle"
      }
    },
    "users": {
      "anonymous": "anonyme",
      "noName": "---",
      "airplx": "AirPlx"
    },
    "buttons": {
      "delete": "Supprimer"
    },
    "deleteDialog": {
      "title": "Supprimer",
      "message": "Voulez-vous vraiment supprimer {{userName}} ?",
      "confirm": "Oui. Supprimer cet utilisateur"
    },
    "errors": {
      "noPermissionModifyRoles": "Vous n'avez pas la permission de modifier les rôles utilisateur.",
      "cannotChangeOwnRole": "Vous ne pouvez pas modifier votre propre rôle.",
      "cannotChangeAirplxRole": "Vous ne pouvez pas modifier le rôle des employés AirPlx.",
      "failedToChangeRole": "Échec du changement de rôle. Veuillez réessayer.",
      "cannotDeleteSelf": "Vous ne pouvez pas vous supprimer.",
      "cannotDeleteAirplx": "Vous ne pouvez pas supprimer les employés AirPlx.",
      "failedToDelete": "Impossible de supprimer l'utilisateur. Réessayez."
    },
    "success": {
      "roleChanged": "Rôle de {{userName}} modifié en {{roleName}}",
      "userDeleted": "Suppression de {{userName}} effectuée",
      "copiedToClipboard": "Copié dans le presse-papiers"
    },
    "invitations": {
      "title": "Invités",
      "noInvites": "Aucune invitation en attente",
      "sentOn": "Envoyé le {{date}} à {{time}}",
      "buttons": {
        "copyLink": "Copier le lien",
        "delete": "Supprimer l'invit.",
        "addTeamMember": "Ajouter un membre",
        "invite": "Inviter"
      },
      "dialog": {
        "title": "Inviter",
        "instructions": "Invitez un nouvel utilisateur sur AirPlx. Saisissez son adresse e-mail ci-dessous et il recevra un e-mail avec les instructions pour rejoindre votre équipe.",
        "successMessage": "Il devrait y avoir un e-mail dans la boîte de réception de {{email}} avec une invitation.",
        "alternativeLink": "Vous pouvez également envoyer ce lien directement à l'utilisateur :",
        "emailLabel": "Adresse e-mail",
        "roleLabel": "Rôle"
      },
      "emailWarning": {
        "title": "Avertissement e-mail personnel",
        "message": "Vous ajoutez un membre d'équipe avec une adresse e-mail externe à votre organisation. L'utilisation d'une adresse personnelle (Gmail, iCloud, etc.) est autorisée, mais pensez à retirer l'accès AirPlx de cet utilisateur dans « Paramètres » si nécessaire."
      }
    }
  },
  "integrations": {
    "title": "Intégrations",
    "subtitle": "Connectez AirPlx à vos systèmes externes d'exploitation de vols pour synchroniser automatiquement les plannings de vols et les réservations.",
    "status": {
      "notConfigured": "Non configuré",
      "disabled": "Désactivé",
      "enabled": "Activé"
    },
    "lastSync": {
      "never": "Jamais",
      "justNow": "À l'instant",
      "minutesAgo": "il y a {{count}} minute",
      "hoursAgo": "Il y a {{count}} heure"
    },
    "flightBridge": {
      "name": "FlightBridge",
      "subtitle": "Gestion des opérations de vol",
      "description": "Synchronisez automatiquement les horaires de vol, les détails des aéronefs et les réservations conciergerie depuis la plateforme d'opérations aériennes FlightBridge.",
      "tooltips": {
        "credentialsVerified": "Identifiants vérifiés",
        "cannotConnect": "Connexion impossible - vérifiez vos identifiants"
      },
      "labels": {
        "companyId": "ID entreprise :",
        "airportCodes": "Codes aéroport :",
        "lastSync": "Dern. sync. :",
        "error": "Erreur :"
      },
      "buttons": {
        "configure": "Configurer",
        "setUp": "Configurer",
        "disable": "Désactiver"
      },
      "disableDialog": {
        "title": "Désactiver l'intégration FlightBridge ?",
        "message": "La synchronisation s'arrêtera immédiatement. Vous pouvez la réactiver à tout moment depuis cette page.",
        "confirm": "Désactiver"
      },
      "configDialog": {
        "title": "Configuration FlightBridge",
        "tabs": {
          "basicConfig": "Config. de base",
          "locationMapping": "Correspondance des lieux"
        },
        "fields": {
          "companyId": {
            "label": "ID entreprise",
            "helper": "Votre identifiant d'entreprise FlightBridge"
          },
          "apiEnvironment": {
            "label": "Environnement API",
            "production": "Production API (https://api.flightbridge.com)",
            "test": "Test API (https://testapi.flightbridge.com)"
          },
          "airportCodes": {
            "label": "Codes aéroport",
            "placeholder": "KJFK, JFK",
            "helper": "Codes ICAO/IATA séparés par des virgules. Seuls les vols arrivant ou partant de ces aéroports seront importés."
          },
          "username": {
            "label": "Identifiant"
          },
          "password": {
            "label": "Mot de passe"
          },
          "enabled": {
            "label": "Activé",
            "tooltip": "Activer l'intégration FlightBridge pour synchroniser automatiquement les plannings de vols et les réservations. Une fois activée, les vols seront importés depuis FlightBridge et apparaîtront dans votre planning."
          },
          "syncLocationUpdates": {
            "label": "Synchroniser les mises à jour de position vers FlightBridge",
            "tooltip": "Lorsque des aéronefs sont déplacés dans AirPlx (AutoPark, déplacements manuels, etc.), leur position est automatiquement mise à jour dans FlightBridge. Les mises à jour s'effectuent en arrière-plan sous 1 à 5 secondes."
          }
        },
        "buttons": {
          "test": "Tester la connexion et aperçu",
          "testing": "Test...",
          "viewPreview": "Aperçu des données",
          "save": "Enregistrer",
          "saving": "Enregistr…",
          "cancel": "Annuler"
        },
        "messages": {
          "testSuccess": "Authentification réussie ! {{totalCount}} réservations trouvées ({{filteredCount}} correspondant à vos codes aéroport). Cliquez sur « Aperçu des données » pour voir les détails.",
          "testFailed": "Échec du test",
          "testInfo": "Cliquez sur « Tester la connexion et prévisualiser les données » pour vérifier vos identifiants FlightBridge et voir un aperçu des données disponibles avant d'enregistrer.",
          "airportCodesRequired": "Les codes aéroport sont requis",
          "saveFailed": "Échec de l'enregistrement"
        },
        "locationMapping": {
          "loading": "Chargement des correspondances de lieux...",
          "emptyState": "Aucun emplacement FlightBridge découvert pour le moment. Cliquez sur « Tester la connexion et prévisualiser les données » dans l'onglet Configuration de base pour découvrir les emplacements de votre compte FlightBridge.",
          "description": "Associez les emplacements FlightBridge à vos hangars et tarmacs AirPlx. Ces associations seront utilisées lors de la synchronisation des réservations conciergerie.",
          "unmappedWarning": "{{count}} emplacement non encore cartographié. Les réservations pour les emplacements non cartographiés n'auront pas de hangar ou de tarmac assigné.",
          "table": {
            "headers": {
              "flightBridgeLocation": "Emplacement FlightBridge",
              "airplxLocation": "Emplacement AirPlx",
              "status": "Statut"
            }
          },
          "menu": {
            "notMapped": "Non associé",
            "hangars": "Hangars",
            "ramps": "Tarmacs"
          },
          "status": {
            "mapped": "Associé",
            "unmapped": "Non associé"
          },
          "help": "Les emplacements sont découverts automatiquement lorsque vous testez la connexion FlightBridge. Les modifications sont enregistrées immédiatement lorsque vous sélectionnez une correspondance.",
          "failedSync": "{{count}} mise à jour de position n'a pas pu être synchronisée avec FlightBridge",
          "retry": "Réessai",
          "retrying": "Réessai...",
          "errors": {
            "failedToLoad": "Échec du chargement des localisations",
            "failedToSave": "Échec enregistrement mapping"
          }
        }
      },
      "dataPreviewDialog": {
        "title": {
          "success": "Résultats des tests FlightBridge",
          "failed": "Échec du test FlightBridge"
        },
        "auth": {
          "failed": "Échec de l'authentification :",
          "success": "Authentification réussie"
        },
        "errorDetails": {
          "title": "Détails de l'erreur technique",
          "message": "Message :",
          "code": "Code :",
          "httpStatus": "État HTTP :"
        },
        "stats": {
          "dateRange": "Période",
          "totalReservations": "Réservations totales"
        },
        "table": {
          "title": "Exemples de réservations (10 max.)",
          "headers": {
            "reservationId": "Numéro de réservation",
            "tailNumber": "Immatriculation",
            "locationOnField": "Emplacement terrain",
            "arrivalTime": "Heure d'arrivée",
            "departureTime": "Heure de départ",
            "status": "Statut",
            "workflow": "Workflow",
            "services": "Services"
          },
          "values": {
            "notProvided": "Non renseigné",
            "unknown": "Inconnu",
            "none": "Aucun"
          }
        },
        "workflow": {
          "cancelled": "Annulé",
          "requested": "Demandé",
          "inProgress": "En cours",
          "completed": "Terminé",
          "archived": "Archivé",
          "rejected": "Refusé",
          "unknown": "Inconnu",
          "notApplicable": "—"
        },
        "noData": {
          "title": "Aucune réservation trouvée pour votre entreprise au cours des 7 derniers jours. Cela peut signifier :",
          "reasons": {
            "noReservations": "Aucune réservation conciergerie n'a été créée",
            "outsideWindow": "Toutes les réservations sont en dehors de la fenêtre de 7 jours",
            "incorrectId": "L'identifiant entreprise semble incorrect"
          }
        },
        "errors": {
          "title": "Erreurs"
        },
        "footer": {
          "duration": "Test terminé en {{duration}} ms",
          "close": "Fermer"
        }
      }
    }
  },
  "opsCenter": {
    "airportConfig": {
      "title": "Configuration de l'aéroport",
      "subtitle": "Configurez le code aéroport et le nom pour le centre Ops de ce FBO.",
      "icaoLabel": "Code ICAO",
      "icaoPlaceholder": "KBZN",
      "icaoHelper": "L'identifiant ICAO de l'aéroport à 4 lettres (ex. : KBZN, KJFK)",
      "nameLabel": "Nom de l'aéroport",
      "namePlaceholder": "Bozeman Yellowstone International",
      "nameHelper": "Nom d'affichage de l'aéroport"
    },
    "notifications": {
      "title": "Paramètres de notification",
      "subtitle": "Configurez les notifications que vous recevez dans Ops Center.",
      "arrivingSoon": "Arrivée imminente",
      "etaChanges": "Modif. ETA",
      "landed": "Atterri",
      "departed": "Parti",
      "alertLeadTime": "Délai d'alerte",
      "leadTime15": "15 minutes",
      "leadTime30": "30 minutes",
      "leadTime60": "60 minutes"
    },
    "uiPreferences": {
      "title": "Préférences IU",
      "subtitle": "Configurez l'interface utilisateur du Ops Center.",
      "showLivePositions": "Positions aéronefs en direct"
    },
    "noteTags": {
      "title": "Étiquettes",
      "subtitle": "Gérer les étiquettes des notes de vol.",
      "loading": "Chargement...",
      "placeholder": "Nom d'étiquette",
      "addButton": "Étiquette",
      "success": {
        "added": "Tag ajouté avec succès",
        "removed": "Étiquette supprimée"
      },
      "errors": {
        "addFailed": "Échec de l'ajout du tag",
        "removeFailed": "Échec de la suppression du tag"
      }
    },
    "serviceDisplay": {
      "title": "Affichage des services",
      "subtitle": "Configurez les services affichés sous forme de badges et leur ordre.",
      "loading": "Chargement de la configuration du service...",
      "sections": {
        "primaryBadges": "Badges principaux",
        "primaryDescription": "Ces services sont affichés sous forme de badges sur les lignes de vol. Glissez pour réorganiser.",
        "otherServices": "Autres services",
        "otherDescription": "Ces services sont disponibles mais ne sont pas affichés sous forme de badges."
      },
      "fields": {
        "label": "Libellé d'affichage"
      },
      "buttons": {
        "remove": "Supprimer",
        "add": "Ajouter"
      },
      "services": {
        "fuel": "Fuel",
        "hangar": "Hangar",
        "catering": "Restauration",
        "hotel": "Hôtel",
        "crewCar": "Véhicule",
        "limo": "Limo",
        "carRental": "Location auto",
        "arrivalLimo": "Limo arrivée",
        "departureLimo": "Limousine départ",
        "deicing": "Dégivrage",
        "groundPower": "Alim. au sol",
        "gpu": "GPU",
        "lavatory": "Toilettes",
        "water": "Eau",
        "towing": "Tractage",
        "oxygen": "Oxygène",
        "conferenceRoom": "Salle de réunion",
        "customs": "Douane",
        "payment": "Paiement",
        "dishes": "Plats",
        "linens": "Linges",
        "otherArrival": "Autre (Arrivée)",
        "otherDeparture": "Autre (Départ)",
        "cip": "Cip",
        "confRoomShort": "Salle de conf.",
        "lav": "WC"
      },
      "success": {
        "movedToPrimary": "Service déplacé vers les badges principaux",
        "movedToOther": "Service transféré vers d'autres services"
      },
      "errors": {
        "loadFailed": "Échec du chargement de la configuration du service",
        "updateFailed": "Échec de la mise à jour du service",
        "reorderFailed": "Échec de la réorganisation des services"
      }
    }
  },
  "hangarSettings": {
    "title": "Locataires de base pour {{hangarName}}",
    "table": {
      "headers": {
        "name": "Nom du hangar",
        "dimensions": "Dimensions",
        "wallSpacing": "Espacement murs",
        "baseTenants": "Locataires de base"
      }
    },
    "buttons": {
      "modify": "Modifier",
      "delete": "Supprimer",
      "copy": "Copier",
      "cancel": "Annuler",
      "uploadImage": "Téléverser une image de référence",
      "cancelSetup": "Annuler config.",
      "saveHangar": "Enregistrer"
    },
    "copyDialog": {
      "title": "Copier le hangar",
      "fboLabel": "Copier au FBO",
      "copyButton": "Copier le hangar"
    },
    "deleteDialog": {
      "title": "Voulez-vous vraiment supprimer {{hangarName}} ?",
      "message": "Ce hangar et toutes les informations sur ses locataires seront supprimés. Les locataires de base de ce hangar deviendront non assignés.",
      "confirmButton": "Supprimer le hangar"
    },
    "emptyState": {
      "title": "Aucun hangar configuré",
      "description": "Cliquez sur « Ajouter un hangar » ci-dessus pour configurer votre premier hangar."
    },
    "tabs": {
      "basicInfo": "Infos de base",
      "dimensions": "Dimensions",
      "heightBays": "Hauteur et travées",
      "features": "Fonctions"
    },
    "titles": {
      "editHangar": "Modifier le hangar : {{name}}"
    },
    "confirmations": {
      "saveChanges": {
        "title": "Enregistrer ?",
        "message": "Voulez-vous vraiment enregistrer ces modifications ?"
      }
    },
    "labels": {
      "referenceImage": "Image de référence",
      "display": "Afficher ?",
      "untitled": "Sans titre",
      "autostackingEnabled": "Empilement auto activé ?"
    },
    "success": {
      "saved": "Hangar mis à jour."
    },
    "errors": {
      "unknown": "Erreur inconnue",
      "saveFailed": "Échec de l'enregistrement : {{error}}"
    },
    "dimensionsForm": {
      "labels": {
        "hangarName": "Nom du hangar",
        "width": "Largeur ({{unit}})",
        "depth": "Profondeur ({{unit}})",
        "grossSquareFootage": "Surface brute",
        "usableSquareFootage": "Surface utile (pi²)",
        "doorPockets": "Pochettes de porte",
        "leftDoorLength": "Longueur porte gauche ({{unit}})",
        "rightDoorLength": "Longueur porte droite ({{unit}})",
        "doorDimensions": "Dimensions des portes",
        "doorWidth": "Largeur ({{unit}})",
        "heightConfiguration": "Configuration de la hauteur",
        "useBayHeights": "Hauteurs par hangar",
        "height": "Hauteur ({{unit}})",
        "garageDoors": "Portes de hangar",
        "noGarageDoors": "Aucune porte de hangar. Cliquez Ajouter pour en créer.",
        "wall": "Mur",
        "wallLeft": "Gauche",
        "wallBack": "Retour",
        "wallRight": "Droite",
        "garageDoorWidth": "Largeur",
        "obstacles": "Obstacles",
        "wallSpacing": "Espacement murs",
        "leftWall": "Mur gauche ({{unit}})",
        "backWall": "Paroi arrière ({{unit}})",
        "rightWall": "Paroi droite ({{unit}})"
      },
      "obstacleHint": "Utilisez la barre d'outils au-dessus du canevas pour ajouter des obstacles rectangulaires ou polygonaux.",
      "tooltips": {
        "bayHeights": "Activer pour les hangars à débord en escalier avec différentes zones de hauteur. Chaque travée peut avoir sa propre hauteur de débord et hauteur libre.",
        "eaveHeight": "Hauteur sous auvent pour les hangars uniformes. Il s'agit de la hauteur libre verticale entre le sol et le point le plus bas de la structure du toit."
      }
    },
    "bayEditor": {
      "orientations": {
        "lateral": "Latéral (Côte à côte)",
        "longitudinal": "Longitudinal (avant-arrière)"
      },
      "tooltips": {
        "lateral": "┌──┬───┬──┐\n│A │ B │C │\n│  │   │  │\n└──┴───┴──┘\nLes travées se divisent de gauche à droite\nExemple : 3 travées de 80ft, 100ft, 80ft",
        "longitudinal": "┌─────────┐\n│    A    │\n├─────────┤\n│    B    │\n└─────────┘\nLes travées divisent l'avant→l'arrière\nExemple : 2 travées de 60ft, 60ft",
        "bayRange": "Baie couvre {{start}}{{unit}} - {{end}}{{unit}}",
        "baySegment": "Baie {{index}} : {{start}}-{{end}}{{unit}} ({{percent}} %)"
      },
      "labels": {
        "width": "Largeur ({{unit}})",
        "depth": "Profondeur ({{unit}})",
        "eaveHeight": "Ht avant-toit ({{unit}})",
        "clearHeight": "Hauteur libre ({{unit}})"
      },
      "coverage": {
        "total": "Total : {{total}} {{unit}} / {{hangar}} {{unit}} ({{percent}} %)",
        "complete": "✓ Couverture complète",
        "exceeds": "⚠️ Dépasse de {{gap}}{{unit}}",
        "missing": "⚠️ {{gap}}{{unit}} manquant",
        "uncovered": "Période non couverte {{dimension}} : {{start}}{{unit}} - {{end}}{{unit}}",
        "overflowIndicator": "+{{gap}}{{unit}}"
      },
      "buttons": {
        "addBay": "Ajouter",
        "fillRemainder": "Compléter le reste ({{gap}}{{unit}})"
      }
    },
    "newAircraftForm": {
      "labels": {
        "ownerManager": "Propriétaire/Gérant",
        "type": "Type",
        "notes": "Notes",
        "unassigned": "Non attribué",
        "notHangared": "Non hangaré"
      },
      "types": {
        "base": "Base",
        "transient": "Passage",
        "yellowCard": "Base + Carte Jaune"
      },
      "placeholders": {
        "departureTime": "Heure de départ : 24/05/2025 12:00"
      }
    },
    "obstacleContextMenu": {
      "copy": "Copier",
      "delete": "Supprimer"
    },
    "obstacleToolbar": {
      "addObstacleTooltip": "Ajouter obstacle",
      "addObstacleButton": "Ajouter obstacle",
      "rightClickHint": "clic droit pour supprimer un obstacle",
      "dialogTitle": "Ajouter obstacle/zone sans tow",
      "polygonDialogTitle": "Ajouter un obstacle polygonal",
      "tools": {
        "select": "Choisir",
        "rectangle": "Rectangle",
        "polygon": "Polygone",
        "circle": "Cercle"
      },
      "polygonHints": {
        "clickToAddPoints": "Ajouter des points",
        "minThreePoints": "Ajoutez au moins 3 points",
        "clickFirstPointToClose": "Cliquez le premier point pour fermer"
      },
      "circleHints": {
        "clickToPlaceCenter": "Cliquez pour placer le point central"
      },
      "circleDialogTitle": "Ajouter un obstacle circulaire",
      "circleInfo": "Infos cercle",
      "centerPosition": "Centre",
      "polygonInfo": "Infos polygone",
      "pointCount": "Points",
      "boundingBox": "Zone délimitée",
      "heightHint": "La hauteur est facultative. Indiquez-la si l'obstacle impose des restrictions de hauteur pour le placement des aéronefs.",
      "obstacleTypes": {
        "obstruction": "obstruction",
        "noTowArea": "zone sans tract",
        "unobstructive": "discret",
        "caution": "Attention"
      },
      "labels": {
        "type": "Type",
        "width": "Largeur ({{unit}})",
        "depth": "Profondeur ({{unit}})",
        "height": "Hauteur ({{unit}})",
        "diameter": "Diamètre ({{unit}})"
      },
      "buttons": {
        "cancel": "Annuler",
        "add": "+"
      }
    },
    "bulkAdd": {
      "tabs": {
        "byMakeModel": "Ajouter par marque et modèle",
        "byTailNumbers": "Ajouter par immatriculations"
      },
      "labels": {
        "searchByMakeModel": "Rechercher par marque et modèle",
        "numAircraft": "# Aéronefs",
        "tailNumbers": "Immatriculations",
        "selectAircraftType": "Sélectionner le type d'aéronef"
      },
      "placeholders": {
        "tailNumbersMultiline": "N12345\nN54321\nN67890",
        "tailNumbersComma": "ex. N12345, N54321, N67890"
      },
      "buttons": {
        "search": "Recherche",
        "addAircraft": "Ajouter un aéronef",
        "remove": "Supprimer",
        "addMoreTailNumbers": "Ajouter des immatriculations",
        "add": "+"
      },
      "messages": {
        "enterOneTailPerLine": "Entrez un numéro d'immatriculation par ligne.",
        "allTailsFound": "✓ Tous les immatriculations trouvés en base",
        "unknownTailNumbersTitle": "Immatriculations inconnues",
        "unknownTailNumbersInstructions": "Les immatriculations suivantes n'ont pas été trouvées dans la base de données. Veuillez sélectionner le type d'aéronef pour chacune ou les retirer :",
        "aircraftAddedToList": "✓ Les aéronefs ont été ajoutés à la liste ci-dessous",
        "maxAircraftWarning": "Le nombre maximum d'aéronefs à ajouter est de 20.",
        "existingTailNumberWarning": "Un aéronef avec l'immatriculation {{tailNumber}} existe déjà. Nous avons ajouté l'immatriculation existante et le modèle d'aéronef associé.",
        "tailNumbersOptional": "Facultatif. Séparez les immatriculations par des virgules."
      },
      "table": {
        "headers": {
          "tailNumber": "N° immat.",
          "model": "Modèle",
          "type": "Type",
          "direction": "Direction"
        }
      }
    },
    "tenantSelector": {
      "table": {
        "headers": {
          "lastHangared": "Dernier hangarage"
        }
      },
      "search": {
        "placeholder": "Rechercher par locataire ou immat."
      },
      "buttons": {
        "removeAircraft": "Retirer l'aéronef",
        "addAircraft": "Ajouter un aéronef"
      },
      "status": {
        "inLocation": "À {{locationName}}"
      },
      "dialog": {
        "confirmTitle": "Veuillez confirmer"
      },
      "messages": {
        "aircraftAdded": "{{model}} ajouté à {{locationName}}"
      }
    },
    "autocompleteAircraft": {
      "defaultLabel": "Aéronef",
      "suggested": "(suggéré)",
      "noOptionsButton": "Aucun aéronef trouvé • Cliquez ici pour demander un nouvel aéronef",
      "newAircraftRequest": {
        "title": "Nouvelle demande d'aéronef",
        "successTitle": "Demande reçue",
        "labels": {
          "manufacturer": "Constructeur",
          "model": "Modèle",
          "uniqueModifiers": "Modificateurs uniques (ex. : winglets, variantes)",
          "timeframe": "Période"
        },
        "messages": {
          "successMessage": "Merci ! Nous allons traiter votre demande dès que possible. Nous pourrions vous contacter par e-mail si nous avons des questions sur les spécificités de l'appareil que vous souhaitez ajouter, veuillez donc surveiller votre boîte de réception.",
          "uploadTimeframe": "Prévoyez 2 à 4 jours pour l'ajout de nouveaux modèles d'avion. Nous vous informerons dès qu'il sera disponible."
        }
      }
    },
    "addTripTab": {
      "labels": {
        "ownerManager": "Propriétaire/Gérant",
        "type": "Type",
        "notes": "Notes",
        "arrivalDateTime": "Date et heure d'arrivée",
        "departureDateTime": "Date et heure de départ",
        "noDeparture": "Aucun départ"
      },
      "placeholders": {
        "ownerManager": "p. ex., Jean Dupont",
        "notes": "Notes facultatives sur ce vol..."
      },
      "tenantTypes": {
        "transient": "Passage",
        "base": "Base",
        "yellowCard": "Base + Carte Jaune"
      },
      "messages": {
        "noDepartureInfo": "Cet aéronef restera au FBO indéfiniment sans départ prévu.",
        "existingTrips": "Vols existants pour {{tailNumber}} :",
        "avoidOverlap": "Veuillez choisir des dates différentes pour éviter tout chevauchement",
        "checkDatesWarning": "Vérifiez les dates pour éviter les chevauchements – les vols ne peuvent pas se chevaucher",
        "autoAssignedInfo": "Ce vol sera automatiquement assigné à l'emplacement {{locationType}} actuel.",
        "overlapError": "Un autre vol se chevauche. Veuillez actualiser et sélectionner des dates différentes."
      }
    },
    "allTripsTab": {
      "labels": {
        "unassigned": "Non attribué",
        "startDate": "Date de début",
        "endDate": "Date de fin"
      },
      "placeholders": {
        "filterTailOrOwner": "Filtrer immat. ou proprio"
      },
      "status": {
        "cancelled": "Annulé",
        "past": "Passé",
        "active": "Actif",
        "future": "Futur",
        "today": "Auj.",
        "tomorrow": "Demain",
        "thisWeek": "Cette semaine",
        "nextWeek": "Sem. proch.",
        "thisMonth": "Ce mois-ci"
      },
      "columns": {
        "tailNumber": "Immatriculation",
        "arrival": "Arrivée",
        "departure": "Départ",
        "duration": "Durée",
        "status": "Statut",
        "location": "Emplacement",
        "actions": "Actions"
      },
      "buttons": {
        "hidePast": "Masquer passé",
        "showPast": "Voir passé",
        "delete": "Supprimer"
      },
      "dialogs": {
        "deleteTitle": "Supprimer vols ?"
      },
      "errors": {
        "loadFailed": "Chargement des vols échoué",
        "selectLocation": "Veuillez sélectionner un emplacement dans le filtre déroulant avant d'attribuer des vols",
        "locationNotFound": "Emplacement sélectionné introuvable",
        "assignFailed": "Échec de l'attribution des vols",
        "unassignFailed": "Échec de la désaffectation des vols",
        "cancelFailed": "Échec de l'annulation des vols",
        "deleteFailed": "Suppression des vols échouée"
      }
    },
    "addSelectedTenant": {
      "table": {
        "headers": {
          "tailNumber": "N° immat.",
          "model": "Modèle",
          "currentLocation": "Position actuelle",
          "lastHangared": "Dernier hangarage",
          "type": "Type"
        }
      },
      "status": {
        "inHoldingArea": "En zone d'attente",
        "inThisHangar": "Dans ce hangar",
        "inLocation": "Dans {{locationName}}"
      },
      "buttons": {
        "add": "Ajout"
      },
      "unassignedText": "Non hangaré"
    },
    "customizeHeatmap": {
      "loading": "Chargement..."
    }
  },
  "stackingSOPs": {
    "titles": {
      "hangarStacking": "Empilage hangar",
      "normalSpacing": "Espacement normal",
      "looseSpacing": "Espacement large",
      "tightSpacing": "Espacement réduit",
      "rampSpacing": "Espacement au sol"
    },
    "labels": {
      "horizontalSpacing": "Espacement horizontal ({{unit}})",
      "verticalSpacing": "Espacement vertical ({{unit}})",
      "allowOverlap": "Chevauchement ?"
    },
    "noseInThresholds": {
      "title": "Paramètres Nose-In/Tail-In",
      "tooltipText": "AirPlx utilise la hauteur la plus basse du stabilisateur horizontal pour déterminer l'orientation par défaut lorsqu'un nouvel aéronef est ajouté à un hangar. Utilisez le curseur ci-dessous pour ajuster la hauteur du stabilisateur horizontal à partir de laquelle AirPlx définira par défaut Tail-in, No-Preset ou Nose-In. Par exemple :",
      "tooltipExamples": {
        "allTailIn": "Si vous préférez garer tous les aéronefs en marche arrière, déplacez les deux curseurs complètement vers la droite.",
        "below20TailIn": "Pour garer les aéronefs de moins de 20{{unit}} queue en premier et les autres nez en premier, réglez les deux curseurs sur 20{{unit}}."
      },
      "tooltipNote": "Remarque : Vous pouvez ajuster l'orientation de chaque appareil à l'intérieur de chaque hangar selon vos besoins.",
      "orientations": {
        "tailIn": "Arrivée",
        "noPreset": "Aucun modèle",
        "noseIn": "Nez entré"
      },
      "resetButton": "Réinitialiser par défaut"
    },
    "tabs": {
      "baseWide": "SOPs de la base",
      "locationOverrides": "Substitutions de lieu"
    },
    "baseWide": {
      "description": "Configurez les paramètres d'espacement et d'orientation par défaut qui s'appliquent à tous les hangars et aires de stationnement. Ces paramètres peuvent être modifiés par emplacement dans l'onglet Exceptions par emplacement."
    },
    "overrides": {
      "name": "Nom",
      "status": "Statut",
      "actions": "Actions",
      "edit": "Édit.",
      "overrideCount": "{{count}} exception(s)",
      "usingBaseWide": "SOP de la base",
      "description": "Remplacer les paramètres SOP de la base pour des hangars ou aires de stationnement spécifiques. Les emplacements sans remplacement utiliseront les paramètres de la base.",
      "hangars": "Hangars",
      "ramps": "Tarmacs",
      "noHangars": "Aucun hangar configuré",
      "noRamps": "Aucun tarmac configuré",
      "editTitle": "Dérogations SOP pour {{name}}",
      "editDescription": "Remplacer les paramètres SOP de la base pour cet emplacement. Laissez les champs vides pour utiliser les valeurs par défaut de la base.",
      "orientationThresholds": "Seuils d'orientation",
      "fboDefault": "FBO par défaut : {{value}}",
      "resetAll": "Réinitialiser",
      "saveSuccess": "Modifications des SOP enregistrées",
      "saveError": "Échec enregistrement dérogations SOP"
    }
  },
  "rampsSettings": {
    "buttons": {
      "addRamp": "Ajouter un tarmac",
      "modify": "Modifier",
      "delete": "Supprimer",
      "copy": "Copier",
      "cancel": "Annuler"
    },
    "table": {
      "headers": {
        "name": "Nom du tarmac",
        "dimensions": "Dimensions"
      }
    },
    "copyDialog": {
      "title": "Copier le tarmac",
      "fboLabel": "Copier au FBO",
      "copyButton": "Copier le tarmac"
    },
    "deleteDialog": {
      "title": "Voulez-vous vraiment supprimer {{rampName}} ?",
      "message": "Ce tarmac et toute sa configuration seront supprimés.",
      "confirmButton": "Supprimer le tarmac"
    },
    "emptyState": {
      "title": "Aucun tarmac configuré",
      "description": "Cliquez sur « Ajouter un tarmac » ci-dessus pour configurer votre premier tarmac."
    },
    "labels": {
      "rampName": "Nom du tarmac",
      "width": "Largeur ({{unit}})",
      "depth": "Profondeur ({{unit}})"
    },
    "rampEditorForm": {
      "editRamp": "Modifier",
      "boundingBoxCoordinates": "Coordonnées de délimitation",
      "coordinates": {
        "topLeft": "Haut gauche",
        "topRight": "Haut-droite",
        "bottomRight": "Bas-droite",
        "bottomLeft": "Bas-gauche"
      },
      "confirmations": {
        "saveChanges": {
          "message": "Enregistrer",
          "title": "Enregistrer"
        }
      },
      "messages": {
        "needCalibrationPoints": "Calibration requise"
      }
    },
    "rampEditor": {
      "title": "Modifier",
      "saveSuccess": "Modifications enregistrées.",
      "properties": "Propriétés",
      "rampVersion": "Version du tarmac",
      "v2Algorithm": "Algorithme V2",
      "editName": "Cliquer pour renommer",
      "namePlaceholder": "Nom du tarmac",
      "unsavedChanges": {
        "title": "Modifs non sauvées",
        "message": "Vous avez des modifications non enregistrées. Voulez-vous vraiment quitter ?",
        "exitButton": "Quitter sans enregistrer",
        "stayButton": "Rester"
      },
      "gisShapeEditGrid": {
        "warningOutOfBounds": "Cette forme pourrait ne pas être visible dans la zone de délimitation actuelle du tarmac",
        "placeholderShapeText": "Forme texte",
        "presetLabel": "Préréglé",
        "strokeLabel": "Contour",
        "fillLabel": "Rempl.",
        "doneButton": "Fait",
        "noShapes": "Aucune forme à afficher",
        "instructions": "Cliquez sur le texte ou la taille pour modifier. Utilisez l'icône pour les couleurs et étiquettes.",
        "applyDefaultStyling": "Appliquer le style par défaut",
        "headers": {
          "textLabel": "Texte/Label",
          "tags": "Tags",
          "colors": "Couleurs",
          "fontSize": "Taille police",
          "actions": "Actions"
        },
        "shapeCount": "Nombre de formes"
      },
      "toolbar": {
        "selectSpotSize": "Sélectionner taille",
        "sections": {
          "options": "Options",
          "calibrationPoints": "Points de calibration"
        },
        "options": {
          "image": "Image",
          "measurements": "Mesures",
          "rampV2": "Tarmac v2.0",
          "autoParking": "AutoParking",
          "guideLines": "Directives",
          "showPoints": "Voir les points"
        },
        "tooltips": {
          "downloadImage": "Télécharger l'image du tarmac",
          "uploadImage": "Nouvelle image du tarmac",
          "compressImage": "Compresser l'image existante"
        },
        "tabs": {
          "tools": "Outils",
          "shapes": "Formes",
          "hangars": "Hangars"
        },
        "buttons": {
          "finishedAdding": "Ajout terminé",
          "addPoint": "Ajouter"
        },
        "bulkOperations": "Opérations groupées",
        "noHangarsAvailable": "Aucun hangar disponible",
        "spotSizes": {
          "verySmall": "Très petit (x40ft)",
          "small": "Petit (x60ft)",
          "midsize": "Moyen (x80ft)",
          "superMid": "S-Mid (x100ft)",
          "large": "Grand (x120ft)"
        },
        "snackbar": {
          "imageSaved": "Enregistré {{kb}} Ko ({{percent}} %)",
          "compressionFailed": "Échec de la compression. Consultez la console pour les détails."
        }
      },
      "referenceAircraft": {
        "toolButton": "Aéronef de référence",
        "toolTooltip": "Ajouter un aéronef de référence pour la comparaison d'échelle",
        "dialog": {
          "title": "Sélectionner l'aéronef de référence",
          "description": "Choisissez un aéronef à afficher comme référence d'échelle sur le canevas. Faites glisser pour déplacer, appuyez sur R pour pivoter.",
          "searchLabel": "Rechercher un aéronef",
          "currentAircraft": "Aéronef sélectionné",
          "dimensions": "{{wingspan}} pi d'envergure x {{length}} pi de longueur",
          "clearButton": "Supprimer la référence",
          "applyButton": "Valider",
          "cancelButton": "Annuler"
        },
        "hints": {
          "drag": "Glisser-déplacer",
          "rotate": "R pour pivoter, Maj+R sens antihoraire",
          "delete": "Supprimer"
        }
      },
      "rampInitialize": {
        "title": "Créer un tarmac",
        "rampNameLabel": "Nom du tarmac",
        "uploadImageButton": "Téléverser l'image de référence du tarmac",
        "calibrationInstructions": "Veuillez tracer une ligne de référence sur l'image. Nous l'utiliserons pour calibrer l'échelle de votre aire de stationnement, des pixels vers les {{unit}}.",
        "redoButton": "Rétab",
        "confirmButton": "Parfait",
        "continueButton": "Continuer la configuration",
        "dropImageHint": "Glissez-déposez une image du tarmac ici",
        "setupHint": "Après le téléversement, vous calibrerez l'image en utilisant les coordonnées GPS pour définir des dimensions précises."
      },
      "compassRoseExists": "La rose des vents existe déjà sur ce tarmac",
      "recalibrate": "Recalibrer GPS",
      "calibrationPointDialog": {
        "position": "Position : ({{x}}, {{y}})",
        "addButton": "Ajouter bouton",
        "cancelButton": "Bouton Annuler",
        "coordinatesLabel": "Libellé des coordonnées",
        "coordinatesPlaceholder": "Entrer les coordonnées",
        "latitudeLabel": "Libellé de latitude",
        "longitudeLabel": "Libellé de longitude",
        "titleAdd": "Ajouter titre",
        "titleEdit": "Modifier titre",
        "updateButton": "Bouton Modifier"
      },
      "calibrationPointsList": {
        "noPoints": "Aucun point de calibration défini",
        "position": "Position"
      },
      "rampCanvasToolbar": {
        "typeLabel": "Type",
        "tools": {
          "measuringTool": "Outil de mesure",
          "modifyOutline": "Modifier le plan",
          "addHazard": "Ajouter danger",
          "unknown": "Inconnu"
        },
        "tooltips": {
          "save": "Enregistrer",
          "delete": "Supprimer"
        },
        "markingTypes": {
          "whiteSolid": "Blanc uni",
          "whiteDashed": "Blanc pointillé",
          "yellowSolid": "Jaune uni",
          "yellowDashed": "Jaune pointillé",
          "redSolid": "Rouge uni",
          "grey": "Gris"
        }
      },
      "spotTilePicker": {
        "hoverPrompt": "Survolez un emplacement pour prévisualiser",
        "gridSize": "Grille : {{width}}x{{height}}"
      },
      "gisImport": {
        "title": "Importer données GIS",
        "sections": {
          "formatRequirements": "Exigences de format",
          "importedShapes": "Formes importées ({{count}})"
        },
        "format": {
          "delimiter": "<strong>Délimiteur :</strong> Séparé par tabulation (TSV)",
          "requiredColumns": "<strong>Colonnes requises :</strong> geometry (format WKT)",
          "optionalColumns": "<strong>Colonnes facultatives :</strong> ramp_label, stroke_color, fill_color, font_size",
          "sampleNote": "Téléchargez le fichier exemple ci-dessous pour référence."
        },
        "defaults": {
          "shapeName": "Forme importée"
        },
        "buttons": {
          "cancel": "Annuler",
          "downloadSample": "Télécharger un exemple",
          "processCSV": "Traiter le fichier",
          "import": "Importer {{count}} formes"
        },
        "errors": {
          "calibrationPoints": "Au moins 2 points de calibration sont requis pour la transformation de coordonnées",
          "processingFailed": "Échec du traitement du fichier"
        }
      },
      "spotProperties": {
        "disabled": {
          "label": "Désactivé",
          "tooltip": "Lorsque cette option est activée, cet emplacement sera exclu des calculs AutoPark"
        },
        "allowedSizes": {
          "label": "Tailles d'aéronefs autorisées",
          "tooltip": "Restreindre les tailles d'aéronefs autorisées sur cet emplacement. Les tailles inférieures sont toujours autorisées si des tailles supérieures sont permises.",
          "spotSize": "Emplacement adapté : envergure ~{{feet}} pi ({{category}})",
          "tooLarge": "(trop grand)"
        },
        "egressLanes": {
          "label": "Voies de sortie",
          "tooltip": "Sélectionnez les voies de circulation que cet emplacement peut utiliser pour la sortie. Les aéronefs ne seront placés ici que si au moins une voie de sortie est disponible.",
          "noneSelected": "Aucune sélection",
          "noLanesDefined": "Aucune voie définie sur ce tarmac",
          "laneLabel": "Voie {{id}}"
        },
        "gapSpot": {
          "label": "Gap Spot",
          "tooltip": "Les emplacements tampons servent de zones de séparation entre les aéronefs. Lorsqu'ils sont activés, ces emplacements ne peuvent être utilisés que si tous les emplacements adjacents requis sont occupés.",
          "checkboxLabel": "Activer comme créneau",
          "requiredSpots": "Places requises (doivent toutes être occupées) :",
          "noneDetected": "Aucun emplacement adjacent détecté"
        },
        "maxDwellTime": {
          "label": "Temps d'escale max",
          "tooltip": "Durée maximale de stationnement d'un aéronef sur cet emplacement (ex : rotations rapides)",
          "inputLabel": "Heures max",
          "placeholder": "Sans limite",
          "helperText": "Laisser vide pour aucune limite"
        },
        "minDwellTime": {
          "label": "Temps d'escale min.",
          "tooltip": "Durée minimale de stationnement d'un aéronef sur cet emplacement (ex. : pour les places réservées aux nuitées)",
          "inputLabel": "Heures min.",
          "placeholder": "Aucun minimum",
          "helperText": "Laisser vide pour aucun minimum"
        },
        "blockingSpots": {
          "label": "Relations bloquantes",
          "tooltip": "Affiche les emplacements qui bloquent cet emplacement et ceux que cet emplacement bloque",
          "none": "Aucune relation bloquante",
          "noBlocks": "Ne bloque aucun emplacement"
        },
        "tiling": {
          "label": "Mosaïque",
          "tooltip": "Créer une grille d'emplacements basée sur les dimensions de cet emplacement",
          "button": "Créer grille tuiles",
          "bufferLabel": "Marge (pi)"
        }
      },
      "shapeEdit": {
        "mixedTypes": "Types de formes mixtes",
        "actions": {
          "delete": "Supprimer",
          "copy": "Copier",
          "cancel": "Annuler",
          "ok": "OK"
        },
        "algorithm": {
          "referencePoints": "Points de référence",
          "orientations": {
            "nose": "Nez",
            "tail": "Queue",
            "overhang": "Débordement",
            "center": "Centre"
          },
          "refPoints": {
            "north": {
              "label": "Nord",
              "tooltip": "Point de référence côté nord du spot"
            },
            "south": {
              "label": "Sud",
              "tooltip": "Point de référence côté sud du spot"
            },
            "east": {
              "label": "Est",
              "tooltip": "Point de référence côté est du spot"
            },
            "west": {
              "label": "Ouest",
              "tooltip": "Point de référence sur le côté ouest du spot"
            },
            "center": {
              "label": "Centre",
              "tooltip": "Point de référence au centre du spot"
            }
          },
          "noValue": "—",
          "zoneProperties": "Propriétés de la zone",
          "zoneDisabled": {
            "label": "Désactivé",
            "tooltip": "Lorsque cette option est activée, cette zone sera exclue des calculs AutoPark"
          },
          "stagingArea": {
            "label": "Zone de transit",
            "tooltip": "Marquer cette zone comme aire de stationnement temporaire"
          },
          "overflowParking": {
            "label": "Zone de débordement",
            "tooltip": "Utilisez cette zone si les emplacements principaux sont complets"
          },
          "zoneName": {
            "label": "Nom de zone",
            "placeholder": "Nom de la zone",
            "helperText": "Nom d'affichage facultatif pour cette zone"
          },
          "zonePriority": "Priorité de zone",
          "zonePriorityHelp": "Zones prioritaires privilégiées pour le stationnement (0=min, 10=max)",
          "aircraftOrientation": "Orientation de l'aéronef",
          "noseToLine": "Nez vers la ligne",
          "priority": "Priorité",
          "settings": "Paramètres",
          "tailToLine": "Tail To Line"
        },
        "properties": {
          "locked": "Verrouillé",
          "tags": "Tags",
          "text": "Texte"
        },
        "styling": {
          "color": "Couleur",
          "custom": "Perso.",
          "fill": "Rempl.",
          "fontSize": "Taille police",
          "line": "Ligne",
          "lineStyle": "Style de ligne",
          "lineWidth": "Épaisseur",
          "pattern": "Modèle",
          "prefixedColors": "Couleurs préfixées",
          "showText": "Afficher",
          "text": "Texte",
          "textPosition": "Position du texte"
        },
        "tabs": {
          "algorithm": "Algorithme",
          "properties": "Propriétés",
          "styling": "Style"
        },
        "title": "Édit. forme"
      },
      "canvasTextInput": {
        "title": "Modifier",
        "nameLabel": "Texte",
        "cancel": "Annuler",
        "save": "Enregistrer"
      },
      "egressCalculation": {
        "close": "Fermer",
        "details": {
          "blocksLabel": "Libellé des blocs",
          "gapSpotNote": "Note d'écart",
          "title": "Détails"
        },
        "spotAnalysis": {
          "blockedByTooltip": "Bloqué par - Info-bulle",
          "blocksTooltip": "Infobulle des blocs",
          "headers": {
            "blockedByCount": "Nombre de blocages",
            "blockingCount": "Nombre de blocages",
            "egressLane": "Voie de sortie",
            "egressLaneTooltip": "Voie de sortie - Info-bulle",
            "hasLane": "A une voie",
            "spot": "Place",
            "status": "Statut"
          },
          "noLane": "Sans voie",
          "title": "Analyse de position",
          "zeroCount": "Aucun résultat"
        },
        "summary": {
          "blockingRelationships": "Relations bloquantes",
          "title": "Résumé",
          "totalSpots": "Places totales",
          "withEgressLane": "Avec voie de sortie",
          "withoutEgressLane": "Sans voie de sortie"
        },
        "title": "Calcul de sortie"
      },
      "textEdit": {
        "cancel": "Annuler",
        "color": "Couleur",
        "ok": "Ok",
        "size": "Taille",
        "text": "Texte",
        "title": "Éditer texte"
      }
    },
    "rampCalibrationCanvas": {
      "referenceDistanceDialog": {
        "description": "Description",
        "distanceLabel": "Libellé de distance",
        "title": "Distance de référence"
      }
    },
    "setupWizard": {
      "complete": "Configuration terminée !",
      "calibrate": {
        "clickToPlace": "Cliquez sur l'image pour placer le point de calibration {{label}}",
        "enterGPS": "Entrez les coordonnées GPS pour ce point",
        "ready": "Prêt à calibrer"
      },
      "confirm": {
        "finish": "Terminer la configuration"
      },
      "gps": {
        "title": "Coordonnées GPS",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "latError": "La latitude doit être entre -90 et 90",
        "lngError": "La longitude doit être entre -180 et 180",
        "emptyError": "Veuillez entrer les coordonnées"
      },
      "review": {
        "continue": "Continuer"
      }
    }
  },
  "revenueEstimator": {
    "tabs": {
      "rates": "Tarifs",
      "feeCalculator": "Calculateur de frais"
    },
    "migration": {
      "message": "Le calculateur de frais est désormais accessible via la barre de navigation latérale. Cliquez ci-dessous pour accéder au calculateur de frais.",
      "button": "Calculateur de frais"
    },
    "rateCalculator": {
      "title": "Aidez-moi à calculer mes tarifs actuels",
      "subtitle": "Si vous ne connaissez pas vos tarifs mensuels habituels pour les locataires ou vos tarifs journaliers pour les transients, utilisez ce calculateur pour les déterminer. Entrez simplement un exemple d'aéronef et le montant total que vous facturez actuellement pour voir l'équivalent en tarifs mensuels ou journaliers.",
      "headers": {
        "aircraft": "Aéronef",
        "dimensions": "Longueur x Envergure",
        "totalArea": "Surface totale",
        "totalFee": "Frais total",
        "pricePerArea": "$/{{unit}}"
      },
      "labels": {
        "makeModel": "Marque/Modèle",
        "rate": "Tarif"
      },
      "formats": {
        "dimensions": "{{length}}L x {{wingspan}}ENV",
        "area": "{{area}} {{unit}}"
      }
    },
    "feeCalculator": {
      "headers": {
        "aircraft": "Aéronef",
        "dimensions": "Longueur x Envergure",
        "buffer": "Tampon",
        "totalArea": "Surface totale",
        "rate": "Tarif",
        "cam": "CAM",
        "total": "Total",
        "totalWithCam": "Total + CAM"
      },
      "tooltips": {
        "buffer": "Une marge est ajoutée à chaque extrémité des dimensions. Ex. : une marge de 2 pi ajoute un total de 4 pi à la longueur et 4 pi à l'envergure.",
        "rate": "Saisissez vos tarifs souhaités ci-dessous. Vous pouvez également modifier les tarifs par défaut en accédant à Paramètres → Estimation → Tarifs.",
        "cam": "Frais d'entretien des parties communes ajoutés au loyer mensuel du locataire"
      },
      "labels": {
        "makeModel": "Marque/Modèle",
        "buffer": "Tampon",
        "monthlyRate": "$ / {{unit}} / mois",
        "dailyRate": "$ / {{unit}} / jour",
        "tenantMonthly": "Locataire (mensuel)",
        "transientDaily": "Passage (journalier)"
      },
      "formats": {
        "totalArea": "{{area}} {{unit}}",
        "dimensions": "{{length}}L x {{wingspan}}WS",
        "camUnit": "$/{{unit}}²"
      }
    },
    "common": {
      "empty": "---"
    },
    "annualTenantTable": {
      "labels": {
        "annualIncrease": "Augmentation annuelle (%)",
        "aircraftFee": "Frais aéronef",
        "camFees": "Frais CAM",
        "totalFee": "Frais total",
        "year": "Année {{number}}"
      }
    },
    "ratesForm": {
      "labels": {
        "label": "Libellé",
        "baseTenantRate": "Tarif de base locataire",
        "transientRate": "Tarif passage",
        "defaultLabel": "Par défaut",
        "newRate": "Nouv. tarif",
        "defaultBuffer": "Marge par défaut",
        "buffer": "Tampon",
        "defaultCAM": "Frais d'entretien des parties communes par défaut",
        "or": "OU"
      },
      "buttons": {
        "addRate": "Ajouter"
      },
      "tooltips": {
        "buffer": "Une marge est ajoutée à chaque extrémité des dimensions. Ex. : une marge de {{value}}{{unit}} ajoute un total de {{total}}{{unit}} à la longueur et {{total}}{{unit}} à l'envergure.",
        "cam": "Frais d'entretien des parties communes ajoutés au loyer mensuel du locataire. Vous pouvez spécifier un pourcentage ou un montant au {{unit}}²."
      }
    }
  },
  "towingEquipment": {
    "headers": {
      "name": "Nom",
      "length": "Longueur ({{unit}})",
      "width": "Largeur ({{unit}})",
      "height": "Hauteur ({{unit}})",
      "towBarLength": "Barre de tractage ({{unit}})"
    },
    "buttons": {
      "add": "+",
      "remove": "Supprimer",
      "makeDefault": "Définir par défaut"
    },
    "labels": {
      "default": "Par défaut",
      "notAvailable": "S/O"
    }
  },
  "customizeHeatmap": {
    "title": "Heatmap",
    "sections": {
      "refPoints": "Pts de réf.",
      "preview": "Aperçu points de réf."
    },
    "labels": {
      "refPointX": "Point de réf. X",
      "refPointY": "Point de réf. Y",
      "dimensions": "{{value}} ft"
    },
    "buttons": {
      "add": "Ajouter",
      "preview": "Aperçu"
    }
  },
  "uberAdmin": {
    "executionMatrix": {
      "components": {
        "aircraft": "Aéronef",
        "obstacles": "Obstacles",
        "towingEquip": "Équip. remorquage"
      },
      "headers": {
        "component": "Composant",
        "prod": "Prod",
        "worker1": "Opérat. 1",
        "worker2": "Worker2"
      },
      "legend": {
        "error": "Erreur",
        "na": "Na",
        "skipped": "Ignoré",
        "success": "Succès"
      },
      "noDetails": "Aucun détail",
      "title": "Matrice d'exécution"
    }
  }
}
